import { CoObjectItem, TgkDropDownSource } from "../components/interfaces/CoObject";
import { formatMessage } from "../utils/helpers/LanguageHelper";
import { createContentControlForCoObject } from "./ContentControl";
import { getContentControlById } from "./WordDocumentPart";

/* global Word */

export function insertDropDownList(coObject: CoObjectItem): Promise<any> {
  return Word.run(async (context) => {
    const ccId = await createContentControlForCoObject(coObject);
    const wordContentControl = await getContentControlById(context, ccId);

    createContent(wordContentControl, coObject);
    await context.sync();
    return wordContentControl.id;
  }).catch((error) => {
    // eslint-disable-next-line no-undef
    console.log(error);
  });
}

export function updateDropDownList(coObject: CoObjectItem): Promise<any> {
  return Word.run(async (context) => {
    const wordContentControl = context.document.contentControls.getById(Number(coObject.contentControlId));
    const range = wordContentControl.getRange("Content");
    range.clear();
    createContent(wordContentControl, coObject);

    await context.sync();
    return coObject.contentControlId;
  }).catch((error) => {
    // eslint-disable-next-line no-undef
    console.log(error);
  });
}

function createContent(wordContentControl: Word.ContentControl, coObject: CoObjectItem) {
  wordContentControl.title = coObject.info.objectName;
  wordContentControl.cannotEdit = false;
  wordContentControl.cannotDelete = true;
  let message = formatMessage("cof.base.selectitem");

  let dropdownlistOOXML_PREFIX =
    '<pkg:package xmlns:pkg="http://schemas.microsoft.com/office/2006/xmlPackage"> <pkg:part pkg:name="/_rels/.rels" pkg:contentType="application/vnd.openxmlformats-package.relationships+xml" > <pkg:xmlData> <Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships"> <Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument" Target="word/document.xml"/> </Relationships> </pkg:xmlData> </pkg:part> <pkg:part pkg:name="/word/document.xml" pkg:contentType="application/vnd.openxmlformats-officedocument.wordprocessingml.document.main+xml"> <pkg:xmlData> <w:document xmlns:w="http://schemas.openxmlformats.org/wordprocessingml/2006/main" > <w:body> <w:sdt> <w:sdtPr> <w:dropDownList> ';
  let dropdownlistOOXML_SUFFIX = `</w:dropDownList> </w:sdtPr> <w:sdtContent> <w:p> <w:r> <w:rPr /> <w:t>${message}</w:t> </w:r> </w:p> </w:sdtContent> </w:sdt> </w:body> </w:document> </pkg:xmlData> </pkg:part> </pkg:package>`;

  let dropdownlistOOXML_CONTENT: string = "";

  let source: TgkDropDownSource = coObject.source as TgkDropDownSource;
  for (const tgkDropDownItem of source.dropDownList) {
    dropdownlistOOXML_CONTENT = dropdownlistOOXML_CONTENT.concat(
      '<w:listItem w:value="'
        .concat(tgkDropDownItem.value)
        .concat('" w:displayText="'.concat(tgkDropDownItem.key).concat('"/>'))
    );
  }
  let dropdownlistOOXML: string = dropdownlistOOXML_PREFIX
    .concat(dropdownlistOOXML_CONTENT)
    .concat(dropdownlistOOXML_SUFFIX);

  wordContentControl.insertOoxml(dropdownlistOOXML, Word.InsertLocation.start);
}
